{
  "de": {
    "empty": {
      "headlines": {
        "default": "Keine Ergebnisse",
        "forName": "Keine %{name} gefunden",
        "hangar": "Ihr Hangar ist leer",
        "wishlist": "Ihre Wunschliste ist leer",
        "features": "Keine Funktionen verfügbar"
      },
      "actions": {
        "reset": "Filter/Seiten zurücksetzen",
        "resetPage": "Zur ersten Seite"
      },
      "texts": {
        "info": "Wir konnten keine Einträge finden.",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "Derzeit sind keine Self-Service-Funktionen verfügbar. Schauen Sie später wieder vorbei, da regelmäßig neue Funktionen hinzugefügt werden."
      }
    }
  }
}
